import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { EToggleMobileMenuActionType, TToggleMobileMenu } from './types';
import { IMenu } from '../../../types/menu';

export const toggleMobileMenu: (isShown: IMenu['isMobileMenuOpened']) => TToggleMobileMenu = actionGenerator<
  EToggleMobileMenuActionType.Set,
  IMenu['isMobileMenuOpened']
>(EToggleMobileMenuActionType.Set);
